import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, of, switchMap } from 'rxjs';
import { HelperService } from 'src/app/service/helper.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { Feature } from '../model/rootObjectFeature';

@Injectable({
    providedIn: 'root'
})
export class FeatureDataService extends DefaultDataService<Feature> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService, public helperService: HelperService) {
        super('Feature', http, httpUrlGenerator);
    }

    override getAll(): Observable<Feature[]> {
        const url = this.urlProvider.getUrl(EndPoints.userFeature, undefined, undefined);
        return this.http
            .get(
                url,
                (Headers = {
                    ...this.urlProvider.baseGetOptions()
                })
            )
            .pipe(
                switchMap((res: any) => {
                    return of(<Feature[]>res.body['features']);
                })
            );
    }

}
